<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="board.readonly" />

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="관리적요인 개선조치"
      :tableData="[
        { id: 'cell1', title: '개선조치 보고사항', type: 'textarea', placeholder: '내용' },
        { id: 'cell2', title: '조치결과(완료, 진행, 예정)', type: 'text', placeholder: '내용', width: '190px' },
        { id: 'cell3', title: '증빙서류 첨부', type: 'file', width: '290px'},
      ]"
      v-model="form.managementList"
    />

    <!-- 현장 유해위험요인 개선조치 -->
    <div>
      <h5 class="mt-4"><i class="dot"></i> 현장 유해위험요인 개선조치</h5>

      <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div v-for="_title in managementTitle" :key="_title" class="col-span-1 flex items-center">
          <div v-if="isPrint" class="flex items-center">
            <div v-if="form.managementChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox :readonly="board.readonly" v-model="form.managementChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <report-plan
      class="mt-5"
      v-for="(_title, _title_i) in managementTitle"
      :key="`management_${_title}`"
      v-show="form.managementChecked.includes(_title)"
      :section-title="_title"
      :reportPlan="form[`reportPlanList_${_title_i + 1}`]"
      :is-print="isPrint"
      :readonly="board.readonly"
      :is-show-title="true"
      :report-type="_title_i + 1"
    />

    <!-- 확인자 -->
<!--    <div v-if="!isPrint" class="mt-28px">-->
<!--      <div>-->
<!--        <h5><i class="dot"></i> 결재란</h5>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>작성자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign1.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>검토자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign2.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>회람자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign3.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="writeGridContainer mt-4" style="align-items: start">-->
<!--        <div>-->
<!--          <div>승인자</div>-->
<!--          <ml-input v-if="!isPrint" v-model="form.sign4.name" :readonly="board.readonly" />-->
<!--          <span v-else class="print-input">{{ form.sign4.name }}</span>-->
<!--        </div>-->
<!--        <div style="align-items: start">-->
<!--          <div class="pt-2">서명</div>-->
<!--          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign4.sign" class="w-full flex-1 p-1" />-->
<!--          <div v-else class="w-full flex-1 p-1">-->
<!--            <img v-if="form.sign4.sign" :src="form.sign4.sign" width="100%" alt="Signature" class="signatureImg" />-->
<!--            <div v-else class="signatureImg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 파일첨부 -->
    <FileUploadModule id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";

import TableCustom from "@/components/TableCustom.vue";
import ReportPlan from "@/views/boards/single-page/677/ReportPlan.vue";
import SignField from "@/components/SignField.vue";
import Print from "@/views/boards/single-page/677/Print.vue";

export default {
  components: {
    Print,
    SignField, ReportPlan, TableCustom, FieldSelectModule, FieldSelector, DateSelector, FileUploadModule },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    postId() {
      return this.$route.params.postId;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      managementTitle: ["조치보고", "자체개선", "우수사례"],

      form: {
        stdInfo: {},
        managementList: [],
        managementChecked: [],
        reportPlanList_1: [],
        reportPlanList_2: [],
        reportPlanList_3: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        fileList: [],
      },
    };
  },
  methods: {
    setPrevBoardOptions() {
      const boardId = 669;
      const btnLabel = '결과보고서 불러오기';
      const prevBoardSelectRow = this.prevBoardSelectRow;
      this.$emit("setPrevBoardOptions", { boardId, btnLabel, prevBoardSelectRow });
    },
    prevBoardSelectRow(value) {
      console.log("value", value)
      this.form.managementChecked = value.managementChecked;

      if (value.reportPlanList_1 && value.reportPlanList_1.length > 0) {
        this.form.reportPlanList_1 = value.reportPlanList_1.map((item) => {

          item.file2 = {};
          item.note2 = ""

          return item
        })
      }

      this.form.reportPlanList_2 = value.reportPlanList_2;
      this.form.reportPlanList_3 = value.reportPlanList_3;

      if (value.requirementList && value.requirementList.length > 0) {
        this.form.managementList = value.requirementList.map((item) => {
          return {
            id: item.id,
            cell1: item.cell1,
          };
        });
      }
    },
  },
  created() {
    this.setPrevBoardOptions();
  },
};
</script>
